import React from 'react';
import { Box, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useL10n } from '@uplift/hooks';

import { Button } from '../../Button';


export type FullscreenFormFooterProps = {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  loading?: boolean;
};


const useFullscreenFormFooterStyles = makeStyles()(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    }
  },
  spacer: {
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    }
  },
  footer: {
    background: theme.palette.background.paper,
    position: 'fixed',
    width: '100%',
    bottom: 0,
    left: 0,

    [theme.breakpoints.up('sm')]: {
      position: 'relative',
    }
  },
}));

export const FullscreenFormFooterContainer: React.VFC<{ actionsLeft?: React.ReactNode; actionsRight?: React.ReactNode }> = ({ actionsLeft, actionsRight }) => {
  const { classes } = useFullscreenFormFooterStyles();

  return (
    <Box className={classes.root}>
      <Box p={2} className={classes.spacer}>
        <Button size="large">.</Button>
      </Box>
      <Box className={classes.footer}>
        <Divider />

        <Box p={2} display="flex" justifyContent="space-between">
          <Box display="flex" gap="4px">
            {actionsLeft}
          </Box>
          <Box display="flex" gap="4px">
            {actionsRight}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};


export const FullscreenFormFooter: React.FC<FullscreenFormFooterProps> = ({ onBack, onNext, nextDisabled, loading }) => {
  const l10n = useL10n();

  return (
    <FullscreenFormFooterContainer
      actionsLeft={onBack ? <Button onClick={onBack} size="large" variant="text" startIcon={<ArrowBackIcon />} disabled={loading}>{l10n.navigation.back}</Button> : <Box />}
      actionsRight={onNext ? <Button onClick={onNext} size="large" variant="contained" color="secondary" loading={loading} disabled={nextDisabled} endIcon={<ArrowForwardIcon />}>{l10n.navigation.next}</Button> : <Box />}
    />
  );
};
